module.exports = __webpack_public_path__ + "img/approvalHierachy.1b0406c2.svg";